











































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
})
export default class ControlBox extends Vue {
  @Prop() list: any
  @Prop() current: any
  mounted() {
    console.log('---', this.list)
  }
}
